<template>
  <div id="app" slot="main">
    <slot></slot>
  </div>
</template>

<style lang="scss">
#app {
  width: 100%;
  max-width: 10rem;
  margin: 0 auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>

<script type="text/babel">
import baiduStat from 'lib/tools/baiduStat.js'
export default {
  props: ['description', 'keywords'],
  computed: {
    alidebug() {
      return `!(function(c,b,d,a){c[a]||(c[a]={});c[a].config={pid:"ial18ekfch@9cd2d5f0cda67d7",appType:"web",imgUrl:"https://arms-retcode.aliyuncs.com/r.png?",disableHook:true,sendResource:true,enableSPA:true};
with(b)with(body)with(insertBefore(createElement("script"),firstChild))setAttribute("crossorigin","",src=d)
})(window,document,"https://retcode.alicdn.com/retcode/bl.js","__bl");`
    }
  },
  mounted() {
    try {
      baiduStat()
    } catch (e) {
      console.log(e)
    }
  }
}
</script>
